<template>
  <b-container>
    <!-- Movement Type -->
    <b-form-group
      :label="$t('fuelStock.fields.movementType')"
      label-for="movementType"
    >
      <b-form-select
        id="movementType"
        :placeholder="$t('fuelStock.fields.movementTypeTooltip')"
        v-model="model.movementType"
      >
        <option value=""></option>
        <option value="E">
          {{ $t("fuelStock.fields.movementTypeInbound") }}
        </option>
        <option value="S">
          {{ $t("fuelStock.fields.movementTypeOutbound") }}
        </option>
      </b-form-select>
      <span class="text-danger" v-if="modelstate['MovementType']">
        {{ modelstate["MovementType"][0] }}
      </span>
    </b-form-group>

    <!-- Date movement -->
    <b-form-group
      :label="$t('fuelStock.fields.datetimeMoviment')"
      label-for="datetimeMoviment"
    >
      <b-form-input
        id="datetimeMoviment"
        type="date"
        :placeholder="$t('fuelStock.fields.datetimeMovimentTooltip')"
        v-model="model.datetimeMovement"
      />
      <span class="text-danger" v-if="modelstate['DatetimeMoviment']">
        {{ modelstate["DatetimeMoviment"][0] }}
      </span>
    </b-form-group>

    <!-- Fuel Type -->
    <FuelTypeDropdown
      :fuelTypeId.sync="model.fuelTypeId"
      :modelstate="modelstate"
    />

    <!-- Liters -->
    <b-form-group :label="$t('fuelStock.fields.liters')" label-for="liters">
      <b-form-input
        id="liters"
        type="text"
        :placeholder="$t('fuelStock.fields.litersTooltip')"
        v-model="model.liters"
        v-money-mask
      />
      <span class="text-danger" v-if="modelstate['Liters']">
        {{ modelstate["Liters"][0] }}
      </span>
    </b-form-group>

    <!-- Value per liter -->
    <b-form-group
      :label="$t('fuelStock.fields.valuePerLiter')"
      label-for="valuePerLiter"
    >
      <b-form-input
        id="valuePerLiter"
        type="text"
        :placeholder="$t('fuelStock.fields.valuePerLiterTooltip')"
        v-model="model.valuePerLiter"
        v-money-mask
      />
      <span class="text-danger" v-if="modelstate['ValuePerLiter']">
        {{ modelstate["ValuePerLiter"][0] }}
      </span>
    </b-form-group>

    <!-- Total value -->
    <b-form-group
      :label="$t('fuelStock.fields.totalValue')"
      label-for="totalValue"
    >
      <b-form-input
        id="totalValue"
        type="text"
        :placeholder="$t('fuelStock.fields.totalValueTooltip')"
        v-model="model.totalValue"
        v-money-mask
      />
      <span class="text-danger" v-if="modelstate['TotalValue']">
        {{ modelstate["TotalValue"][0] }}
      </span>
    </b-form-group>
  </b-container>
</template>
    
<script>
import AwesomeMask from "awesome-mask";

export default {
  name: "FuelStockCreateMovementCrud",
  props: {
    model: {
      type: Object,
      description: "Movimentação de estoque",
      default() {
        return {
          movementType: "",
          datetimeMovement: null,
          fuelType: null,
          liters: 0.0,
          valuePerLiter: 0.0,
          totalValue: 0.0,
          fuelSupplyOrigin: null,
        };
      },
    },
    modelstate: {
      type: Object,
      description: "Estado do salvamento",
      default() {
        return {};
      },
    },
  },
  directives: {
    mask: AwesomeMask,
  },
  components: {
    FuelTypeDropdown: () =>
      import("@/components_rms/fuelSupplies/FuelTypeDropdown.vue"),
  },
  created() {
    this.getAllVehicleType();
    // this.dataFormat();
  },
  data() {
    return {
      vehicleTypeOpt: [],
    };
  },
  methods: {
    // FuelType
    getAllVehicleType() {
      this.$apiVehicle.get("/vehicleType/getDropdown/").then((response) => {
        this.vehicleTypeOpt = response.data;
      });
    },
  },
};
</script>
    